import React from "react"

import { ButtonMessageData } from "@/protocols/channel"
import { Variable } from "@/components/ChatMessageBuilder/VariableInput"
import ManageTemplateQuickReplyButton from "@/pages/Admin/Templates/ManageTemplateForm/ManageTemplateButtonsForm/ManageTemplateQuickReplyButton"
import ManageTemplatePhoneNumberButton from "@/pages/Admin/Templates/ManageTemplateForm/ManageTemplateButtonsForm/ManageTemplatePhoneNumberButton"
import ManageTemplateURLButton from "@/pages/Admin/Templates/ManageTemplateForm/ManageTemplateButtonsForm/ManageTemplateURLButton"

import { ValidationType } from "@/hooks/useValidation"

export type ManageTemplateButtonsFormProps = {
	index: number
	button: ButtonMessageData
	variables: Variable[]
	validation?: ValidationType
	handleButtonTextChange: (text: string, index: number) => void
	handleRemoveButtons: (index: number) => void
	handleAddPhoneNumber: (phoneNumber: string, index: number) => void
	handleChangeButtonURL: (url: string, index: number) => void
}

const ManageTemplateButtonsForm: React.FC<ManageTemplateButtonsFormProps> = (props) => {
	const { button, index, variables, validation, handleButtonTextChange, handleRemoveButtons, handleAddPhoneNumber, handleChangeButtonURL } = props

	const getTemplateButtonsForm = () => {
		const buttonsFormMap: Partial<Record<ButtonMessageData["type"], React.ReactNode>> = {
			"quick-reply":
				<ManageTemplateQuickReplyButton
					button={button}
					validation={validation}
					handleButtonTextChange={handleButtonTextChange}
					handleRemoveButtons={handleRemoveButtons}
					index={index}
				/>,
			url:
				<ManageTemplateURLButton
					button={button}
					variables={variables}
					validation={validation}
					handleButtonTextChange={handleButtonTextChange}
					handleRemoveButtons={handleRemoveButtons}
					handleChangeButtonURL={handleChangeButtonURL} index={index}
				/>,
			phone:
				<ManageTemplatePhoneNumberButton
					button={button}
					validation={validation}
					handleButtonTextChange={handleButtonTextChange}
					handleRemoveButtons={handleRemoveButtons}
					handleAddPhoneNumber={handleAddPhoneNumber}
					index={index}
				/>
		}

		return buttonsFormMap[button.type]
	}

	return <>{getTemplateButtonsForm()}</>
}

export default ManageTemplateButtonsForm
